<template>
  <div class="cartContainer">
    <div class="cartListBox">
      <el-button type="success" plain @click="$router.push('/')">{{
        $t("category.jixugouwu")
      }}</el-button>
      <div class="cartTitle">{{ $t("category.myCategory") }}</div>
      <div style="margin: 10px 0"></div>
      <div class="cartListContent" v-for="item in cartList" :key="item.id">
        <img :src="baseUrl + item.spu.image" alt="" class="cartImg" />
        <div class="cartSizeContainer">
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div
              class="cartName"
              style="font-size: 18px; color: #000; font-weight: 700"
            >
              {{ item.spu.name }}
            </div>
            <img
              src="../assets/category/del.png"
              alt=""
              @click="handleDelete(item)"
            />
          </div>
          <div class="details">
            <div>JAN：YMZ00{{ item.spu.id }}</div>
            <div>{{ $t("category.danjia") }}：{{ item.spu.price }}</div>
            <div>
              {{ $t("category.shuliang") }}：
              <el-input-number
                v-model="item.count"
                size="mini"
                :min="minNumer"
              ></el-input-number>
            </div>
            <div>
              {{ $t("category.xiaoji") }}：{{ item.count * item.spu.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="totalContainer">
      <div class="allMount">
        <div class="allMountTitle">
          {{ $t("category.yuyuefanhao") }}：{{ orderId }}
        </div>
        <div>{{ $t("category.hejijine") }}</div>
        <div class="allMountPrice">￥{{ allCount }}</div>
        <div>{{ $t("category.shuliang") }}：{{ buyCount }}</div>
      </div>
      <el-button
        type="success"
        style="width: 95%; position: absolute; bottom: 56px"
        @click="toReservation"
        >{{ $t("category.yuyue") }}</el-button
      >
      <el-button
        type="primary"
        style="width: 95%; position: absolute; bottom: 0px; margin-left: 0"
        @click="$router.push('/login?rediect=shoppingCart')"
        v-if="!isShowBtn"
        >登録して予約</el-button
      >
    </div>
  </div>
</template>

<script>
import { shopCartList, delshopCartList } from "@/api/shopCart";
export default {
  components: {},
  data() {
    return {
      baseUrl: "/proxyApi",
      minNumer: 0,
      orderId: null,
      cartList: [],
      allCount: 0,
      buyCount: 0,
      isShowBtn: sessionStorage.getItem("userID"),
    };
  },

  computed: {},
  watch: {
    cartList: {
      handler(newValue) {
        let initCount = 0;
        let buyCount = 0;
        newValue.forEach((item) => {
          let singleCount = item.spu.price * item.count;
          initCount += singleCount;
          buyCount += item.count;
        });
        this.allCount = initCount;
        this.buyCount = buyCount;
      },
      deep: true,
      // immediate: true,
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      shopCartList()
        .then((res) => {
          // console.log(res);
          this.cartList = res.data.spuList ? res.data.spuList : [];
          this.allCount = res.data.totalPrice;
          this.buyCount = res.data.totalCount;
          this.orderId = res.data.orderId;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleDelete(item) {
      delshopCartList({ spuId: item.spu.id }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.init();
          this.$message.success(res.message);
        }
      });
    },
    toReservation() {
      this.$router.push({
        name: "Reservation",
        query: {
          orderId: this.orderId,
          allCount: this.allCount,
          buyCount: this.buyCount,
          spuList: JSON.stringify(this.cartList),
        },
      });
    },
  },
};
</script>
<style scoped lang='less'>
.cartContainer {
  display: flex;
  width: 65vw;
  min-height: calc(100vh - 42px);
  margin: 0 auto;
  background-color: #f5f7f9;
  box-sizing: border-box;
}
.cartTitle {
  font-size: 20px;
  background-color: #fff;
  padding: 20px 10px;
  margin-top: 10px;
}
.cartListBox {
  width: 65%;
  padding: 20px 10px;
}
.cartImg {
  width: 100px;
  margin-right: 30px;
}

.cartListContent {
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 15px 10px;
  box-sizing: border-box;
}
.cartListContent:hover {
  box-shadow: 0 2px 7px 0 #c0c0c0;
}
.cartSizeContainer {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: flex-start;
  color: #000;
  font-size: 14px;
  .details {
    display: flex;
    align-items: center;
    margin-top: 15px;
    div {
      margin-right: 20px;
    }
  }
  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
.totalContainer {
  position: relative;
  width: 32%;
  height: 350px;
  background-color: #fff;
  padding: 20px 10px;
  margin-top: 70px;
  box-sizing: border-box;
  .allMount {
    text-align: center;
    line-height: 2.5;
  }
  .allMountTitle {
    font-size: 20px;
    color: #11848e;
  }
  .allMountPrice {
    font-size: 25px;
    color: #f00;
  }
}
@media screen and (max-width: 768px) {
  .cartContainer {
    width: 100vw;
    flex-direction: column;
  }
  .cartListContent {
    padding: 5px;
    font-size: 12px;
  }
  .cartListBox {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  .cartImg {
    width: 60px;
    height: 60px;
    margin-right: 10px;
  }
  .cartSizeContainer {
    font-size: 10px;
    .details {
      div {
        margin-right: 10px;
      }
    }
    .cartName {
      font-size: 14px !important;
    }
    img {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .cartTitle {
    font-size: 16px;
    padding: 10px;
  }
  .totalContainer {
    position: relative;
    width: 100%;
    height: 225px;
    background-color: #fff;
    padding: 10px 10px;
    margin-top: 0px;
    box-sizing: border-box;
    .allMount {
      font-size: 14px;
      text-align: center;
      line-height: 1.8;
    }
    .allMountTitle {
      font-size: 14px;
      color: #11848e;
    }
    .allMountPrice {
      font-size: 16px;
      color: #f00;
    }
  }
}
@media all and (min-width: 768px) and (max-width: 1199px) {
  .cartContainer {
    width: 95vw;
  }
  .cartSizeContainer {
    .details {
      div {
        margin-right: 10px;
      }
    }
  }
}
</style>